import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { PageHeader, PageBody } from "@/components/common/PageHeader";
import { Button } from "@/components/ui/button";
import { Lock, Unlock } from "lucide-react";
import { toast } from "sonner";

export default function FiscalPeriods() {
    const [items, setItems] = useState([]);
    const load = async () => { const { data } = await api.get("/fiscal-periods"); setItems(data); };
    useEffect(() => { load(); }, []);

    const lock = async (id) => { await api.post(`/fiscal-periods/${id}/lock`); toast.success("Period locked"); await load(); };
    const unlock = async (id) => { await api.post(`/fiscal-periods/${id}/unlock`); toast.success("Period unlocked"); await load(); };

    return (
        <>
            <PageHeader kicker="ACCOUNTING" title="Fiscal Periods" subtitle="Open and close fiscal periods to control posting." />
            <PageBody>
                <div className="bg-card border border-border rounded-md overflow-hidden">
                    <table className="fin-table">
                        <thead><tr><th>Period</th><th>Start</th><th>End</th><th>Status</th><th></th></tr></thead>
                        <tbody>
                            {items.map((p) => (
                                <tr key={p.id}>
                                    <td className="font-medium">{p.name}</td>
                                    <td>{fmtDate(p.start_date)}</td>
                                    <td>{fmtDate(p.end_date)}</td>
                                    <td>{p.is_locked ? <span className="text-destructive inline-flex items-center gap-1"><Lock className="w-3 h-3" />Locked</span> : <span className="text-positive inline-flex items-center gap-1"><Unlock className="w-3 h-3" />Open</span>}</td>
                                    <td>
                                        {p.is_locked ?
                                            <Button size="sm" variant="outline" onClick={() => unlock(p.id)}>Unlock</Button> :
                                            <Button size="sm" variant="outline" onClick={() => lock(p.id)}>Lock</Button>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </PageBody>
        </>
    );
}
